<template>
  <div class="container-fluid p-5">
    <div class="row">
      <!--colorful cards-->
      <!--<div class="col-lg-3 col-sm-6 my-3">-->
      <!--<div class="card shadow text-white bt-primary mb-1" style="background-color: #957dad; border: 1px">-->
      <!--<a href="/users" style="color: inherit">-->
      <!--<div class="card-body pb-0">-->
      <!--<h4 class="mb-0">{{ dashboardCount.userCount }}</h4>-->
      <!--<p class="card-text">کاربران</p>-->
      <!--<div class="chart" style="height: 10px;">-->
      <!--</div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--</div>-->


      <!--<div class="col-12 my-3">-->
      <!--<VueSlickCarousel :arrows="true" :dots="true" v-bind="settings">-->
      <!--<div>-->
      <!--<div class="col-lg-3 col-sm-6 my-3">-->
      <!--<div class="card shadow text-white bt-success mb-1" style="background-color: #d291bc; border: 1px">-->
      <!--<a href="/order" style="color: inherit">-->
      <!--<div class="card-body pb-0">-->
      <!--<h4 class="mb-0">{{ dashboardCount.orderCount }}</h4>-->
      <!--<p class="card-text">سفارشات</p>-->
      <!--<div class="chart" style="height: 10px;">-->
      <!--</div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div>-->
      <!--<div class="col-lg-3 col-sm-6 my-3">-->
      <!--<div class="card shadow text-white bt-success mb-1" style="background-color: #d291bc; border: 1px">-->
      <!--<a href="/order" style="color: inherit">-->
      <!--<div class="card-body pb-0">-->
      <!--<h4 class="mb-0">{{ dashboardCount.orderCount }}</h4>-->
      <!--<p class="card-text">سفارشات</p>-->
      <!--<div class="chart" style="height: 10px;">-->
      <!--</div>-->
      <!--</div>-->
      <!--</a>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->

      <!--</VueSlickCarousel>-->
      <!--&lt;!&ndash;<VueSlickCarousel :arrows="true" :dots="true" v-bind="settings">&ndash;&gt;-->
      <!--&lt;!&ndash;<div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="col-lg-3 col-sm-6 my-3">&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="card shadow text-white bt-success mb-1" style="background-color: #d291bc; border: 1px">&ndash;&gt;-->
      <!--&lt;!&ndash;<a href="/order" style="color: inherit">&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="card-body pb-0">&ndash;&gt;-->
      <!--&lt;!&ndash;<h4 class="mb-0">{{ dashboardCount.orderCount }}</h4>&ndash;&gt;-->
      <!--&lt;!&ndash;<p class="card-text">سفارشات</p>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="chart" style="height: 10px;">&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</a>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->

      <!--&lt;!&ndash;</VueSlickCarousel>&ndash;&gt;-->

      <!--</div>-->


      <div class="col-lg-3 col-sm-6 my-3">
        <div class="card shadow text-white bt-success mb-1" style="background-color: #d291bc; border: 1px">
          <a href="/order" style="color: inherit">
            <div class="card-body pb-0">
              <h4 class="mb-0">{{ dashboardCount.orderCount }}</h4>
              <p class="card-text">سفارشات</p>
              <div class="chart" style="height: 10px;">
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 my-3">
        <div class="card shadow text-white bt-warning mb-1" style="background-color: #f2c6b4; border: 1px">
          <a href="/planning-orders" style="color: inherit">
            <div class="card-body pb-0">
              <h4 class="mb-0">{{ dashboardCount.productCount }}</h4>
              <p class="card-text">محصول سفارشی</p>
              <div class="chart" style="height: 10px;">
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 my-3">
        <div class="card shadow text-white bt-danger mb-1" style="background-color: #99e1e5; border: 1px">
          <a href="/customerWorks" style="color: inherit">
            <div class="card-body pb-0">
              <h4 class="mb-0">{{ dashboardCount.workCount }}</h4>
              <p class="card-text">کارها</p>
              <div class="chart" style="height: 10px;">
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!--charts-->
    <div class="row">

      <div class="col-lg-8 col-12 my-3">
        <div class="card shadow text-white mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="product-chart" width="870" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 my-3">
        <div class="card shadow text-white  mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="order-chart" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--************************************************************************-->
      <div class="col-lg-12 col-12 my-3">
        <div class="card shadow text-white mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="company-stock-chart" width="1600" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>

      <!--************************************************************************-->
      <div class="col-lg-6 col-12 my-3">
        <div class="card shadow text-white mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="delivery-chart" width="600" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 my-3">
        <div class="card shadow text-white  mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="all-planing-chart" width="600" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!--************************************************************************-->
      <div class="col-lg-4 col-12 my-3">
        <div class="card shadow text-white  mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="total-time-chart" width="400" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-12 my-3">
        <div class="card shadow text-white  mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="work-chart" width="860" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--************************************************************************-->

    <div class="col-lg-12 col-12 my-5">
      <div class="card shadow text-white mb-1">
        <div class="card-body pb-0">
          <div class="card-chart">
            <canvas id="area-chart" width="1600" height="400"></canvas>
          </div>
        </div>
      </div>
    </div>
    <!--************************************************************************-->
  </div>
  </div>
</template>

<script>

  import chart from "chart.js";
  import * as $ from "jquery";
  import Moment from 'moment-jalali';
  import Utils from "../_framework/utils/Utils";
  import BaseService from "../_framework/api/BaseService";
  // import { Swiper, SwiperSlide } from 'swiper/vue';
  // import 'swiper/css';
  import VueSlickCarousel from 'vue-slick-carousel'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


  export default {
    name: 'home',
    components: {
      Moment,
      // Swiper,
      // SwiperSlide,
      VueSlickCarousel,
    },
    // setup() {
    //   const onSwiper = (swiper) => {
    //     console.log(swiper);
    //   };
    //   const onSlideChange = () => {
    //     console.log('slide change');
    //   };
    //   return {
    //     onSwiper,
    //     onSlideChange,
    //   };
    // },
    data() {
      return {

        date: '',
        chats: {
          data: []
        },
        settings: {
          "arrows": true,
          "dots": true,
          "infinite": true,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "autoplay": true,
          "speed": 2000,
          "autoplaySpeed": 2000,
          "cssEase": "linear"
        },

        polarChart: {},
        barChart: {},
        areaChart: {},
        workshopChartData: {
          labels: [],
          data: {
            inQueue: [],
            doing: [],
            done: [],
            problem: [],
            confirm: []
          }
        },
        workStateAreaChartData: {
          labels: [],
          date: [],
          data: {
            inQueue: [],
            doing: [],
            done: [],
            problem: [],
            confirm: []
          }
        },
        pieChartLabels: [],
        canvasFont: null,
        dashboardCount: {},

        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],
        orders: {},
        products: {},

      }
    },
    mounted() {
      this.getDashboardCount();


    },
    methods: {
      getDashboardCount() {
        new BaseService("Report", "/GetDashboardCounts").getList().then(response => {
          this.dashboardCount = response.data;
          this.getWorkshops();
        })
      },

      getWorkshops() {
        new BaseService("WorksReports", "/CompaniesWorksStatus").getList().then(response => {
          for (let item of response.data) {
            this.workshopChartData.labels.push(item.name);
            this.workshopChartData.data.inQueue.push(item.inQueueWorks);
            // this.workshopChartData.data.done.push(item.doneWorks);
            // this.workshopChartData.data.doing.push(item.doingWorks);
            this.workshopChartData.data.confirm.push(item.confirmWorks);
            this.workshopChartData.data.problem.push(item.problemWorks);
          }

          var ctx = document.getElementById('work-chart').getContext('2d');
          var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: this.workshopChartData.labels,
              datasets: [
                {
                  label: 'در انتظار',
                  data: this.workshopChartData.data.inQueue,
                  backgroundColor: 'rgba(255,193,7,0.71)',
                  borderColor: "rgba(255,143,0,0.71)"
                },
                {
                  label: 'درحال انجام',
                  data: this.workshopChartData.data.doing,
                  backgroundColor: 'rgba(205,220,57,0.71)',
                  borderColor: "rgba(135,150,40,0.71)"
                },
                {
                  label: 'مشکل',
                  data: this.workshopChartData.data.problem,
                  backgroundColor: 'rgba(249,60,103,0.71)',
                  borderColor: "rgba(198,40,40,0.71)"
                },
                {
                  label: 'انجام شده',
                  data: this.workshopChartData.data.done,
                  backgroundColor: 'rgba(3,169,244,0.71)',
                  borderColor: "rgba(3,169,244,0.71)"
                },
                {
                  label: 'تایید شده',
                  data: this.workshopChartData.data.confirm,
                  backgroundColor: 'rgba(76,175,80,0.71)',
                  borderColor: "rgba(76,175,80,0.7)"
                }
              ]
            }, options: {
              scales: {
                // xAxes: [{
                //   stacked: true,
                //
                // }],
                yAxes: [{
                  stacked: false,
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  }
                }]
              },
              title: {
                display: true,
                text: 'وضعیت و تعداد کارها در هر کارگاه'
              },
            }

          });


          this.getTotalTimePlaning();

        })
      },
      getTotalTimePlaning() {
        //
        new BaseService("Report", "/GetTotalTimePlaning").getList().then(response => {
          const totalTime = response.data.totalShifts;
          // console.log(totalTime);
          if (totalTime.length > 0) {
            let lables = [];
            let timingData = [];
            let usedTime = [];
            let unusedTime = [];

            for (let lable of totalTime) {
              lables.push(lable.name);
              usedTime.push(lable.used);
              unusedTime.push(lable.unUsed);
            }
            let datause = {
              label: 'استقاده شده',
              backgroundColor: "#facf5a8f",
              hoverBackgroundColor: '#facf5ab5',
              data: usedTime
            };
            timingData.push(datause);
            let dataunuse = {
              label: 'باقیمانده',
              backgroundColor: "#9cf1f68f",
              hoverBackgroundColor: '#9cf1f6b5',
              data: unusedTime
            };
            timingData.push(dataunuse);


            this.polar = new Chart(document.getElementById("total-time-chart").getContext('2d'), {
              type: 'polarArea',
              data: {
                labels: lables,
                datasets: timingData
              },
              options: {
                title: {
                  display: true,
                  text: 'ساعات در دسترس و ساعات برنامه ریزی شده'
                },
                fill: {
                  type: 'gradient',
                  gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100]
                  }
                },
              }
            });
          }

          this.getOrders();
        });
      },
      getOrders() {
        new BaseService("Report", "/GetDashboardOrders").getList().then(response => {
          this.orders = response.data;
          this.showOrders();
        });
        new BaseService("Report", "/GetDashboardProducts").getList().then(response => {
          this.products = response.data;
          this.showproducts();
        });
        this.getWorkStateForAreaChart();
      },
      showOrders() {
        //chart font
        Chart.defaults.global.defaultFontFamily = 'shabnam';

        //pie chart
        let lables = [];
        let totalorderData = [];
        let lessorderData = [];
        let orderData = [];

        for (let i = 0; i < this.orders.length; i++) {
          totalorderData.push(this.orders[i].totalOrder);
          lessorderData.push(this.orders[i].lessOrder);
          lables.push(this.orders[i].orderCode);
        }

        let data = {
          label: 'سفارش',
          backgroundColor: "#facf5a8f",
          hoverBackgroundColor: '#facf5ab5',
          // data: this.orders[i].totalOrder
          data: totalorderData
        };
        orderData.push(data);
        let data1 = {
          label: 'کسر موجودی',
          backgroundColor: "#fc41268f",
          hoverBackgroundColor: '#fc4126b5',
          // data: this.orders[i].totalOrder
          data: lessorderData
        };
        orderData.push(data1);
        this.polar = new Chart(document.getElementById("order-chart"), {


          // type: 'polarArea',
          type: 'bar',
          data: {
            labels: lables,
            datasets: orderData
          },
          options: {
            scales: {
              // xAxes: [{
              //   stacked: true,
              //
              // }],
              yAxes: [{
                stacked: false,
                ticks: {
                  beginAtZero: true,
                  min: 0,
                }

              }]
            },
            title: {
              display: true,
              text: 'تعداد سفارشات'
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
          }
        })

      },
      showproducts() {
        //chart font
        Chart.defaults.global.defaultFontFamily = 'shabnam';

        //pie chart
        let lables = [];
        let totalorderData = [];
        let lessorderData = [];
        let productionData = [];
        let orderData = [];

        for (let i = 0; i < this.products.length; i++) {
          totalorderData.push(this.products[i].totlaOrder);
          lessorderData.push(this.products[i].totlaStock);
          productionData.push(this.products[i].totlaInProduction);
          lables.push(this.products[i].productName);
        }

        let data = {
          label: 'سفارش',
          backgroundColor: "#facf5a8f",
          hoverBackgroundColor: '#facf5ab5',
          // data: this.orders[i].totalOrder
          data: totalorderData
        };
        orderData.push(data);
        let data1 = {
          label: 'موجودی',
          backgroundColor: "#5d99c68f",
          hoverBackgroundColor: '#5d99c6b5',
          // data: this.orders[i].totalOrder
          data: lessorderData
        };
        orderData.push(data1);
        let data2 = {
          label: 'در دست تولید',
          backgroundColor: "#9cf1968f",
          hoverBackgroundColor: '#9cf196b5',
          // data: this.orders[i].totalOrder
          data: lessorderData
        };
        orderData.push(data2);
        this.polar = new Chart(document.getElementById("product-chart"), {


          // type: 'polarArea',
          type: 'bar',
          data: {
            labels: lables,
            datasets: orderData
          },
          options: {
            // scales: {
            //   xAxes: [{
            //     stacked: true,
            //
            //   }],
            //   yAxes: [{
            //     stacked: true,
            //
            //   }]
            // },
            title: {
              display: true,
              text: 'محصولات سفارشی'
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
          }
        })

      },
      getWorkStateForAreaChart() {
        new BaseService("WorksReports", "/WorkStateWeekTiming").getList().then(response => {
          // console.log(response.data)
          for (let item of response.data) {
            this.workStateAreaChartData.labels.push(item.name);
            this.workStateAreaChartData.date.push(item.date);
            this.workStateAreaChartData.data.inQueue.push(item.inQueue);
            this.workStateAreaChartData.data.done.push(item.done);
            this.workStateAreaChartData.data.doing.push(item.doing);
            this.workStateAreaChartData.data.confirm.push(item.confirm);
            this.workStateAreaChartData.data.problem.push(item.problem);
          }

          this.areaChart = new Chart(document.getElementById("area-chart"), {
            type: 'line',
            data: {
              labels: this.workStateAreaChartData.labels,
              datasets: [
                {
                  backgroundColor: "rgba(255,193,7,0.71)",
                  borderColor: "rgba(255,143,0,0.71)",
                  data: this.workStateAreaChartData.data.inQueue,
                  label: 'در انتظار',
                  fill: 'start',
                  hidden: true,
                },
                {
                  backgroundColor: "rgba(205,220,57,0.71)",
                  borderColor: "rgba(135,150,40,0.71)",

                  data: this.workStateAreaChartData.data.doing,
                  label: 'درحال انجام',
                  fill: 'start',
                },
                {
                  backgroundColor: "rgba(249,60,103,0.71)",
                  borderColor: "rgba(198,40,40,0.71)",
                  data: this.workStateAreaChartData.data.problem,
                  label: 'مشکل',
                  fill: 'start',
                  hidden: true,
                },
                {
                  backgroundColor: "rgba(3,169,244,0.71)",
                  borderColor: "rgba(3,169,244,0.71)",
                  data: this.workStateAreaChartData.data.done,
                  label: 'انجام شده',
                  fill: 'start',
                  hidden: true,
                },
                {
                  backgroundColor: "rgba(76,175,80,0.71)",
                  borderColor: "rgba(76,175,80,0.7)",
                  data: this.workStateAreaChartData.data.confirm,
                  label: 'تایید شده',
                  fill: 'start',
                  hidden: true,
                },
              ]
            },
            options: {
              title: {
                text: 'ساعات ماندن در هر وضعیت در یک روز در مجموع کارها',
                display: true,
                bezierCurve: false
              },
              plugins: {
                filler: {
                  propagate: true
                }
              },
            },
          });
          this.grtDelivryDate();

        });
      },
      grtDelivryDate() {
        new BaseService("Report", "/GetDashboardDelivryDate").getList().then(response => {
          const totalTime = response.data;
          if (totalTime.length > 0) {
            let lables = [];
            let timingData = [];
            let orders = [];
            let stocks = [];

            for (let i = 0; i < totalTime.length; i++) {
              // console.log(this.timeSheets[i].dateTime);
              // totalTime[i].jdateTime = Moment(totalTime[i].date, "jYYYY/jMM/jDD").format("jYYYY-jMM-jDD");
              lables.push(totalTime[i].deliveryDate);
              orders.push(totalTime[i].totlaOrder);
              stocks.push(totalTime[i].totlaStock);
            }
            let datause = {
              label: 'سفارشات',
              backgroundColor: "#facf5a8f",
              hoverBackgroundColor: '#facf5ab5',
              data: orders
            };
            timingData.push(datause);
            let dataunuse = {
              label: 'کسر موجودی',
              backgroundColor: "#9cf1f68f",
              hoverBackgroundColor: '#9cf1f6b5',
              data: stocks
            };
            timingData.push(dataunuse);


            this.polar = new Chart(document.getElementById("delivery-chart").getContext('2d'), {
              type: 'bar',
              data: {
                labels: lables,
                datasets: timingData
              },
              options: {
                title: {
                  display: true,
                  text: 'تاریخ تحویل سفارشات'
                },
                fill: {
                  type: 'gradient',
                  gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100]
                  }
                },
              }
            });

            this.getPlanning();
          }

        });
      },
      getPlanning() {
        let myDate = Moment(new Date());

        let createTimesheet = {
          endDate: (myDate)
        };
        new BaseService('Planning', '/GetAllPlannings').create(createTimesheet).then((response) => {
            let planning = response.data;
            let companies = [];
            let companyShifts = [];
            let shifts = [];
            let shiftsData = [];
            if (planning != null) {
              for (let item of planning.totalShifts) {
                var data = {
                  name: item.name,
                  used: item.unUsed,
                };
                shifts.push(data);
              }
              const mainCompany = "کل ساعات کار شرکت";
              companies.push(mainCompany);
              for (let item of planning.totalCompanyShifts) {
                companies.push(item.name);
              }

              let shIndex = 0;
              for (let mainShift of shifts) {

                companyShifts.push(mainShift.used);
                for (let comp of planning.totalCompanyShifts) {
                  let countt = 0;
                  for (let shift of comp.totalShifts) {
                    if (shift.name === mainShift.name) {
                      countt = shift.used;
                      break;
                    }
                  }
                  companyShifts.push(countt);
                }


                const data = {
                  label: mainShift.name,
                  data: companyShifts,
                  backgroundColor: this.backgroundColor[shIndex],
                  hoverBackgroundColor: this.hoverBackgroundColor[shIndex],

                };
                shiftsData.push(data);
                companyShifts = [];
                shIndex = shIndex + 1;
                if (shIndex > 4) {
                  shIndex = 0;
                }

              }
              var ctx = document.getElementById('all-planing-chart').getContext('2d');
              var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                  labels: companies,
                  datasets: shiftsData,
                }, options: {
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true
                    }]
                  },
                  title: {
                    display: true,
                    text: 'ظرفیت ساعتهای کارگاه ها به مدت 30 روز'
                  },
                }

              });

            }

            this.getAllRawProductsQuantity();

          }
        ).catch((error) => {
          console.log(error)
        })
      },
      getAllRawProductsQuantity() {
        new BaseService('Planning', '/GetAllStockProductsQuantity').getList().then((response) => {
          var rawproductQuantity = response.data;
          rawproductQuantity.forEach(raw =>
            raw.reciptDate = raw.reciptDate.includes("0001") ? "---" : Moment(raw.reciptDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD")
          );


          let lables = [];
          let needData = [];
          let quantityData = [];
          let orderedData = [];
          let orderData = [];
          let index = 0;
          for (let i = 0; i < rawproductQuantity.length; i++) {

            lables.push(rawproductQuantity[i].name + "(" + rawproductQuantity[i].reciptDate + ")");
            needData.push(rawproductQuantity[i].totalNeed);
            quantityData.push(rawproductQuantity[i].totalQuantity);
            orderedData.push(rawproductQuantity[i].totalOrder);
          }


          let data1 = {
            label: 'نیازمندی',
            backgroundColor: this.backgroundColor[index],
            hoverBackgroundColor: this.hoverBackgroundColor[index],
            data: needData
          };
          index++;
          if (index > 5) index = 0;
          let data2 = {
            label: 'موجودی',
            backgroundColor: this.backgroundColor[index],
            hoverBackgroundColor: this.hoverBackgroundColor[index],
            data: quantityData
          };
          index++;
          if (index > 5) index = 0;

          let data3 = {
            label: 'سفارش خرید',
            backgroundColor: this.backgroundColor[index],
            hoverBackgroundColor: this.hoverBackgroundColor[index],
            data: orderedData
          };
          index++;
          if (index > 5) index = 0;

          orderData.push(data1);
          orderData.push(data2);
          orderData.push(data3);

          Chart.defaults.global.defaultFontFamily = 'shabnam';
          this.polar = new Chart(document.getElementById("company-stock-chart"), {


            // type: 'polarArea',
            type: 'bar',
            data: {
              labels: lables,
              datasets: orderData
            },
            options: {
              // scales: {
              //   xAxes: [{
              //     stacked: true,
              //
              //   }],
              //   yAxes: [{
              //     stacked: true,
              //
              //   }]
              // },
              title: {
                display: true,
                text: 'موجودی، نیاز و سفارش مواد اولیه(تاریخ اتمام موجودی)'
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
            }
          })
          // for (let raw of this.rawproductQuantity){
          //   raw.reciptDate = Moment(raw.reciptDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD");
          // }
        }).catch((error) => {
          console.log(error)
        });
      },


    },
    computed: {},
  };
</script>

<style scoped lang="scss">
  /*@media (max-width: 991px) {
      .card-mix-chart {
          width: 600px;
          height: 300px;
      }
  }*/
  .image-container {
    border-radius: 10rem;
  }

  .mix-chart {
    height: 300px;
  }

  .color {
    color: #000;
  }

  #tableOperation {
    font-size: 1.5rem;
    color: #606060;
    position: relative;
  }
</style>
